var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoSearchResults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 82,
    viewBox: "0 0 100 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.2795 14.7969L63.8145 17.3555L59.2538 19.9142L54.7188 17.3555L59.2795 14.7969Z",
    fill: "#85E2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8107 17.3516L63.8493 30.0854L59.2854 32.644L59.25 19.9102L63.8107 17.3516Z",
    fill: "#75D3E3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2538 19.9102L59.2891 32.644L54.7541 30.0854L54.7188 17.3516L59.2538 19.9102Z",
    fill: "#85E2F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7717 17.3438L68.3067 19.9024L63.7427 22.4641L59.2109 19.9024L63.7717 17.3438Z",
    fill: "#85E2F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3061 19.8984L68.3415 32.6323L63.7808 35.1909L63.7422 22.4602L68.3061 19.8984Z",
    fill: "#75D3E3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7427 22.4602L63.7813 35.1909L59.2463 32.6323L59.2109 19.8984L63.7427 22.4602Z",
    fill: "#85E2F2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3061 19.9102L72.8379 22.4719L68.2772 25.0306L63.7422 22.4719L68.3061 19.9102Z",
    fill: "#85E2F2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8342 22.4766L72.8728 35.2073L68.3088 37.7659L68.2734 25.0352L72.8342 22.4766Z",
    fill: "#75D3E3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2772 25.0352L68.3126 37.7659L63.7808 35.2073L63.7422 22.4766L68.2772 25.0352Z",
    fill: "#85E2F2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8303 22.4688L77.3653 25.0274L72.8013 27.586L68.2695 25.0274L72.8303 22.4688Z",
    fill: "#85E2F2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3647 25.0234L77.4001 37.7541L72.8394 40.3159L72.8008 27.5821L77.3647 25.0234Z",
    fill: "#75D3E3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8013 27.5821L72.8399 40.3159L68.3049 37.7541L68.2695 25.0234L72.8013 27.5821Z",
    fill: "#85E2F2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0646 14.7891L41.1032 27.5229L36.5393 30.0815L36.5039 17.3477L41.0646 14.7891Z",
    fill: "#75D3E3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5077 17.3477L36.543 30.0815L32.0113 27.5229L31.9727 14.7891L36.5077 17.3477Z",
    fill: "#85E2F2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5366 12.2344L41.0684 14.793L36.5077 17.3517L31.9727 14.793L36.5366 12.2344Z",
    fill: "#85E2F2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5623 17.3477L45.5977 30.0815L41.0659 27.5229L41.0273 14.7891L45.5623 17.3477Z",
    fill: "#85E2F2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5945 12.2344L50.1263 14.793L45.5623 17.3517L41.0273 14.793L45.5945 12.2344Z",
    fill: "#85E2F2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1225 14.7891L50.1611 27.5229L45.594 30.0815L45.5586 17.3477L50.1225 14.7891Z",
    fill: "#75D3E3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8358 19.9141L22.8712 32.6479L18.3362 30.0893L18.3008 17.3555L22.8358 19.9141Z",
    fill: "#85E2F2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8647 14.7891L27.3997 17.3477L22.8358 19.9063L18.3008 17.3477L22.8647 14.7891Z",
    fill: "#85E2F2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M27.396 17.3555L27.4314 30.0893L22.8674 32.6479L22.832 19.9141L27.396 17.3555Z",
    fill: "#75D3E3"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9748 14.7891L36.5098 17.3477L31.9458 19.9063L27.4141 17.3477L31.9748 14.7891Z",
    fill: "#85E2F2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9458 19.9141L31.9844 32.6479L27.4494 30.0893L27.4141 17.3555L31.9458 19.9141Z",
    fill: "#85E2F2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5054 17.3555L36.5407 30.0893L31.98 32.6479L31.9414 19.9141L36.5054 17.3555Z",
    fill: "#75D3E3"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M54.657 17.3555L54.6924 30.0893L50.1284 32.6479L50.0898 19.9141L54.657 17.3555Z",
    fill: "#75D3E3"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1225 14.7891L54.6576 17.3477L50.0904 19.9063L45.5586 17.3477L50.1225 14.7891Z",
    fill: "#85E2F2"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0904 19.9141L50.129 32.6479L45.594 30.0893L45.5586 17.3555L50.0904 19.9141Z",
    fill: "#85E2F2"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3061 17.3555L22.8411 19.9141L18.2772 22.4727L13.7422 19.9141L18.3061 17.3555Z",
    fill: "#85E2F2"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2772 22.4688L18.3158 35.2026L13.7808 32.644L13.7422 19.9102L18.2772 22.4688Z",
    fill: "#85E2F2"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8374 19.9102L22.8728 32.644L18.312 35.2026L18.2734 22.4688L22.8374 19.9102Z",
    fill: "#75D3E3"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7264 25.0266L13.7618 37.7604L9.22679 35.1987L9.19141 22.4648L13.7264 25.0266Z",
    fill: "#85E2F2"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2827 22.4648L18.3213 35.1987L13.7541 37.7604L13.7188 25.0266L18.2827 22.4648Z",
    fill: "#75D3E3"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7554 19.9102L18.2904 22.4688L13.7264 25.0306L9.19141 22.4688L13.7554 19.9102Z",
    fill: "#85E2F2"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5679 22.4766L45.6032 35.2073L41.0393 37.7659L41.0039 25.0352L45.5679 22.4766Z",
    fill: "#AFA2C2"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0819 25.0352L50.1173 37.769L45.5823 35.2073L45.5469 22.4766L50.0819 25.0352Z",
    fill: "#797086"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6193 22.4766L54.6579 35.2104L50.094 37.769L50.0586 25.0352L54.6193 22.4766Z",
    fill: "#AFA2C2"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1522 25.0352L59.1876 37.769L54.6558 35.2104L54.6172 22.4766L59.1522 25.0352Z",
    fill: "#797086"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16391 27.5899L9.20251 40.3237L4.6675 37.762L4.62891 25.0312L9.16391 27.5899Z",
    fill: "#85E2F2"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7319 25.0312L13.7673 37.7651L9.20656 40.3237L9.16797 27.5899L13.7319 25.0312Z",
    fill: "#75D3E3"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19286 22.4648L13.7279 25.0266L9.16391 27.5852L4.62891 25.0266L9.19286 22.4648Z",
    fill: "#85E2F2"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5679 22.4766L50.1029 25.0352L45.5389 27.5938L41.0039 25.0352L45.5679 22.4766Z",
    fill: "#85E2F2"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0522 25.0312L50.0876 37.7651L45.5269 40.3237L45.4883 27.5899L50.0522 25.0312Z",
    fill: "#75D3E3"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5389 27.5899L45.5775 40.3237L41.0425 37.762L41.0039 25.0312L45.5389 27.5899Z",
    fill: "#85E2F2"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5904 27.5899L54.629 40.3237L50.094 37.7651L50.0586 25.0312L54.5904 27.5899Z",
    fill: "#4F767C"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1811 25.0312L59.2165 37.7651L54.6558 40.3237L54.6172 27.5899L59.1811 25.0312Z",
    fill: "#72AAB3"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6919 27.5899L63.7305 40.3237L59.1955 37.7651L59.1602 25.0312L63.6919 27.5899Z",
    fill: "#797086"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2508 25.0312L68.2861 37.762L63.7222 40.3237L63.6836 27.5899L68.2508 25.0312Z",
    fill: "#AFA2C2"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M13.703 30.1446L13.7383 42.8784L9.20656 40.3198L9.16797 27.5859L13.703 30.1446Z",
    fill: "#797086"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7014 27.5859L63.7399 40.3198L59.176 42.8784L59.1406 30.1446L63.7014 27.5859Z",
    fill: "#72AAB3"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1522 30.1446L59.1876 42.8784L54.6558 40.3198L54.6172 27.5859L59.1522 30.1446Z",
    fill: "#4F767C"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7788 27.5859L72.8174 40.3198L68.2502 42.8784L68.2148 30.1446L72.7788 27.5859Z",
    fill: "#72AAB3"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2186 30.1446L68.254 42.8784L63.7222 40.3198L63.6836 27.5859L68.2186 30.1446Z",
    fill: "#4F767C"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15058 27.5859L13.6856 30.1446L9.12163 32.7032L4.58984 30.1446L9.15058 27.5859Z",
    fill: "#85E2F2"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M9.12163 32.711L9.16023 45.4448L4.62522 42.8862L4.58984 30.1523L9.12163 32.711Z",
    fill: "#85E2F2"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7046 30.1523L13.74 42.8862L9.17922 45.4448L9.14062 32.711L13.7046 30.1523Z",
    fill: "#75D3E3"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2475 30.1523L68.2829 42.8862L63.7222 45.4448L63.6836 32.711L68.2475 30.1523Z",
    fill: "#72AAB3"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6724 32.711L63.711 45.4448L59.176 42.8862L59.1406 30.1523L63.6724 32.711Z",
    fill: "#4F767C"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7466 32.711L72.7852 45.4448L68.2502 42.8862L68.2148 30.1523L72.7466 32.711Z",
    fill: "#4F767C"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3569 30.1523L77.3955 42.8862L72.8316 45.4448L72.793 32.711L77.3569 30.1523Z",
    fill: "#72AAB3"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2436 31.6797L48.2822 44.4135L43.7183 46.9722L43.6797 34.2414L48.2436 31.6797Z",
    fill: "#AFA2C2"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2983 31.6797L57.3369 44.4135L52.773 46.9722L52.7344 34.2414L57.2983 31.6797Z",
    fill: "#AFA2C2"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7466 34.2414L52.7852 46.9722L48.2534 44.4135L48.2148 31.6797L52.7466 34.2414Z",
    fill: "#797086"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8592 34.2414L61.8946 46.9722L57.3628 44.4135L57.3242 31.6797L61.8592 34.2414Z",
    fill: "#797086"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M4.55913 35.2657L4.59773 47.9995L0.0627234 45.4409L0.0273438 32.707L4.55913 35.2657Z",
    fill: "#85E2F2"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M9.12645 32.707L9.16505 45.4409L4.6011 47.9995L4.5625 35.2657L9.12645 32.707Z",
    fill: "#75D3E3"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M4.59129 30.1523L9.12308 32.711L4.55913 35.2696L0.0273438 32.711L4.59129 30.1523Z",
    fill: "#85E2F2"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8836 32.707L81.919 45.4409L77.355 47.9995L77.3164 35.2688L81.8836 32.707Z",
    fill: "#75D3E3"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M77.328 35.2688L77.3666 47.9995L72.8316 45.4409L72.793 32.707L77.328 35.2688Z",
    fill: "#85E2F2"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3569 30.1523L81.8951 32.711L77.328 35.2727L72.793 32.711L77.3569 30.1523Z",
    fill: "#85E2F2"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6968 34.2461L43.7354 46.9768L39.1714 49.5386L39.1328 36.8047L43.6968 34.2461Z",
    fill: "#AFA2C2"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2147 36.8047L48.2501 49.5354L43.7183 46.9768L43.6797 34.2461L48.2147 36.8047Z",
    fill: "#85E2F2"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7639 34.2461L52.8025 46.9768L48.2385 49.5354L48.2031 36.8047L52.7639 34.2461Z",
    fill: "#75D3E3"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2436 31.6797L52.7754 34.2414L48.2147 36.8001L43.6797 34.2414L48.2436 31.6797Z",
    fill: "#85E2F2"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8374 34.2461L61.8728 46.9768L57.3088 49.5354L57.2734 36.8047L61.8374 34.2461Z",
    fill: "#75D3E3"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2983 31.6797L61.8333 34.2414L57.2694 36.8001L52.7344 34.2414L57.2983 31.6797Z",
    fill: "#85E2F2"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2694 36.8047L57.3048 49.5354L52.773 46.9768L52.7344 34.2461L57.2694 36.8047Z",
    fill: "#85E2F2"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0975 37.8204L9.13288 50.5542L4.6011 47.9956L4.5625 35.2617L9.0975 37.8204Z",
    fill: "#797086"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7593 35.2617L22.7946 47.9956L18.2307 50.5542L18.1953 37.8204L22.7593 35.2617Z",
    fill: "#AFA2C2"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2811 37.8235L27.3165 50.5542L22.7815 47.9956L22.7461 35.2617L27.2811 37.8235Z",
    fill: "#797086"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3029 35.2734L77.3415 48.0041L72.7776 50.5659L72.7422 37.8321L77.3029 35.2734Z",
    fill: "#AFA2C2"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1147 36.8008L39.1533 49.5346L34.5894 52.0933L34.5508 39.3594L39.1147 36.8008Z",
    fill: "#AFA2C2"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6646 39.3594L43.7032 52.0933L39.1714 49.5346L39.1328 36.8008L43.6646 39.3594Z",
    fill: "#85E2F2"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1883 36.8008L48.2236 49.5315L43.6597 52.0933L43.6211 39.3594L48.1883 36.8008Z",
    fill: "#75D3E3"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6968 34.2461L48.2318 36.8047L43.6646 39.3634L39.1328 36.8047L43.6968 34.2461Z",
    fill: "#85E2F2"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0952 37.8281L9.13058 50.562L4.56663 53.1237L4.53125 40.3899L9.0952 37.8281Z",
    fill: "#75D3E3"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M4.535 40.3868L4.57038 53.1206L0.0385942 50.5588L0 37.8281L4.535 40.3868Z",
    fill: "#85E2F2"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M4.56395 35.2617L9.09895 37.8204L4.535 40.3821L0 37.8235L4.56395 35.2617Z",
    fill: "#85E2F2"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6216 40.3868L13.6602 53.1206L9.12522 50.562L9.08984 37.8281L13.6216 40.3868Z",
    fill: "#797086"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7303 40.3899L22.7689 53.1237L18.2339 50.562L18.1953 37.8281L22.7303 40.3899Z",
    fill: "#85E2F2"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2905 37.8281L27.3259 50.5588L22.7652 53.1206L22.7266 40.3868L27.2905 37.8281Z",
    fill: "#75D3E3"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7593 35.2617L27.2943 37.8235L22.7303 40.3821L18.1953 37.8204L22.7593 35.2617Z",
    fill: "#85E2F2"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7671 37.8281L72.8025 50.562L68.2385 53.1206L68.2031 40.3868L72.7671 37.8281Z",
    fill: "#AFA2C2"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3029 35.2734L81.8379 37.8321L77.274 40.3907L72.7422 37.8321L77.3029 35.2734Z",
    fill: "#85E2F2"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8296 37.8281L81.8649 50.562L77.3042 53.1206L77.2656 40.3868L81.8296 37.8281Z",
    fill: "#75D3E3"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M77.274 40.3868L77.3126 53.1206L72.7776 50.562L72.7422 37.8281L77.274 40.3868Z",
    fill: "#85E2F2"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1147 36.8008L43.6465 39.3594L39.0858 41.9181L34.5508 39.3594L39.1147 36.8008Z",
    fill: "#85E2F2"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0858 41.9141L39.1212 54.6479L34.5894 52.0893L34.5508 39.3555L39.0858 41.9141Z",
    fill: "#85E2F2"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6349 39.3555L43.6735 52.0893L39.1096 54.6479L39.0742 41.9141L43.6349 39.3555Z",
    fill: "#75D3E3"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M9.06304 42.9375L9.10163 55.6714L4.56663 53.1127L4.53125 40.3789L9.06304 42.9375Z",
    fill: "#85E2F2"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6264 40.3789L13.665 53.1127L9.10109 55.6745L9.0625 42.9407L13.6264 40.3789Z",
    fill: "#75D3E3"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0952 37.8281L13.627 40.3868L9.06304 42.9485L4.53125 40.3899L9.0952 37.8281Z",
    fill: "#85E2F2"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7085 40.3789L22.7471 53.1127L18.1831 55.6714L18.1445 42.9375L22.7085 40.3789Z",
    fill: "#AFA2C2"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2583 42.9375L27.2969 55.6714L22.7652 53.1127L22.7266 40.3789L27.2583 42.9375Z",
    fill: "#797086"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7349 42.9375L72.7735 55.6714L68.2385 53.1127L68.2031 40.3789L72.7349 42.9375Z",
    fill: "#85E2F2"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7671 37.8281L77.2989 40.3868L72.7349 42.9454L68.2031 40.3868L72.7671 37.8281Z",
    fill: "#85E2F2"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2788 40.3789L77.3174 53.1127L72.7534 55.6714L72.7148 42.9375L77.2788 40.3789Z",
    fill: "#75D3E3"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1069 41.9219L39.1423 54.6557L34.5816 57.2143L34.543 44.4805L39.1069 41.9219Z",
    fill: "#AFA2C2"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M43.606 44.4805L43.6446 57.2143L39.1096 54.6557L39.0742 41.9219L43.606 44.4805Z",
    fill: "#797086"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5975 45.504L13.6361 58.2378L9.10109 55.6791L9.0625 42.9453L13.5975 45.504Z",
    fill: "#797086"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2443 42.9453L27.2829 55.6791L22.719 58.2378L22.6836 45.504L27.2443 42.9453Z",
    fill: "#72AAB3"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6795 45.504L22.7149 58.2378L18.1831 55.6791L18.1445 42.9453L22.6795 45.504Z",
    fill: "#4F767C"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7928 45.504L31.8282 58.2378L27.2964 55.6791L27.2578 42.9453L31.7928 45.504Z",
    fill: "#797086"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6936 42.9453L72.7321 55.6791L68.1682 58.2378L68.1328 45.504L72.6936 42.9453Z",
    fill: "#AFA2C2"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M39.078 47.0352L39.1133 59.769L34.5816 57.2104L34.543 44.4766L39.078 47.0352Z",
    fill: "#85E2F2"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6115 44.4766L43.6501 57.2104L39.0862 59.769L39.0508 47.0352L43.6115 44.4766Z",
    fill: "#75D3E3"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1069 41.9219L43.6387 44.4805L39.078 47.0392L34.543 44.4805L39.1069 41.9219Z",
    fill: "#85E2F2"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M9.06786 42.9453L13.6029 45.504L9.03891 48.0626L4.50391 45.504L9.06786 42.9453Z",
    fill: "#85E2F2"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03891 48.0625L9.07751 60.7964L4.5425 58.2377L4.50391 45.5039L9.03891 48.0625Z",
    fill: "#85E2F2"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6069 45.5039L13.6455 58.2377L9.08157 60.7964L9.04297 48.0625L13.6069 45.5039Z",
    fill: "#75D3E3"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1288 48.0625L18.1641 60.7964L13.6323 58.2377L13.5938 45.5039L18.1288 48.0625Z",
    fill: "#797086"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M31.771 45.5039L31.8064 58.2377L27.2456 60.7964L27.207 48.0625L31.771 45.5039Z",
    fill: "#72AAB3"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2154 48.0625L27.254 60.7964L22.719 58.2377L22.6836 45.5039L27.2154 48.0625Z",
    fill: "#4F767C"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3208 48.0625L36.3594 60.7964L31.8244 58.2377L31.7891 45.5039L36.3208 48.0625Z",
    fill: "#797086"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1655 45.5039L68.2009 58.2377L63.6402 60.7964L63.6016 48.0625L68.1655 45.5039Z",
    fill: "#AFA2C2"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1382 48.0664L18.1735 60.8002L13.6096 63.3589L13.5742 50.625L18.1382 48.0664Z",
    fill: "#75D3E3"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6069 45.5039L18.1419 48.0625L13.578 50.6212L9.04297 48.0625L13.6069 45.5039Z",
    fill: "#85E2F2"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M13.578 50.625L13.6134 63.3589L9.08157 60.8002L9.04297 48.0664L13.578 50.625Z",
    fill: "#85E2F2"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2319 48.0664L27.2705 60.8002L22.7066 63.3589L22.668 50.625L27.2319 48.0664Z",
    fill: "#AFA2C2"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6685 50.625L22.7071 63.3589L18.1721 60.8002L18.1367 48.0664L22.6685 50.625Z",
    fill: "#797086"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M36.299 48.0664L36.3376 60.8002L31.7737 63.3589L31.7383 50.625L36.299 48.0664Z",
    fill: "#72AAB3"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M31.742 50.625L31.7774 63.3589L27.2456 60.8002L27.207 48.0664L31.742 50.625Z",
    fill: "#4F767C"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M63.56 48.0664L63.5986 60.8002L59.0315 63.3589L58.9961 50.625L63.56 48.0664Z",
    fill: "#AFA2C2"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1382 48.0664L22.67 50.625L18.106 53.1837L13.5742 50.625L18.1382 48.0664Z",
    fill: "#85E2F2"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6577 50.6211L22.6963 63.3549L18.1323 65.9136L18.0938 53.1797L22.6577 50.6211Z",
    fill: "#75D3E3"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M18.106 53.1797L18.1446 65.9136L13.6096 63.3549L13.5742 50.6211L18.106 53.1797Z",
    fill: "#85E2F2"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1998 53.1829L27.2384 65.9136L22.7066 63.3549L22.668 50.6211L27.1998 53.1829Z",
    fill: "#4F767C"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7742 50.6211L31.8096 63.3549L27.2456 65.9136L27.207 53.1829L31.7742 50.6211Z",
    fill: "#72AAB3"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2701 53.1797L36.3087 65.9136L31.7737 63.3549L31.7383 50.6211L36.2701 53.1797Z",
    fill: "#797086"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M49.935 50.6211L49.9704 63.3549L45.4065 65.9136L45.3711 53.1829L49.935 50.6211Z",
    fill: "#AFA2C2"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4615 53.1829L54.5001 65.9136L49.9651 63.3549L49.9297 50.6211L54.4615 53.1829Z",
    fill: "#797086"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0171 50.6211L59.0524 63.3549L54.4917 65.9136L54.4531 53.1829L59.0171 50.6211Z",
    fill: "#AFA2C2"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2944 53.1758L36.333 65.9096L31.7658 68.4683L31.7305 55.7375L36.2944 53.1758Z",
    fill: "#72AAB3"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3647 53.1836L45.4001 65.9143L40.8394 68.4729L40.8008 55.7422L45.3647 53.1836Z",
    fill: "#AFA2C2"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8514 55.7375L40.89 68.4683L36.355 65.9096L36.3164 53.1758L40.8514 55.7375Z",
    fill: "#797086"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M49.935 50.6211L54.4668 53.1829L49.9029 55.7415L45.3711 53.1829L49.935 50.6211Z",
    fill: "#85E2F2"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4663 53.1836L54.5049 65.9143L49.9409 68.4729L49.9023 55.7422L54.4663 53.1836Z",
    fill: "#75D3E3"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9029 55.7422L49.9415 68.4729L45.4065 65.9143L45.3711 53.1836L49.9029 55.7422Z",
    fill: "#85E2F2"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2944 53.1758L40.8294 55.7375L36.2655 58.2962L31.7305 55.7375L36.2944 53.1758Z",
    fill: "#85E2F2"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8335 55.7422L40.8721 68.4729L36.3081 71.0347L36.2695 58.3008L40.8335 55.7422Z",
    fill: "#75D3E3"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2655 58.3008L36.3041 71.0347L31.7658 68.4729L31.7305 55.7422L36.2655 58.3008Z",
    fill: "#85E2F2"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3647 53.1836L49.8965 55.7422L45.3358 58.3009L40.8008 55.7422L45.3647 53.1836Z",
    fill: "#85E2F2"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3358 58.3008L45.3712 71.0315L40.8394 68.4729L40.8008 55.7422L45.3358 58.3008Z",
    fill: "#85E2F2"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M49.885 55.7422L49.9235 68.4729L45.3596 71.0315L45.3242 58.3008L49.885 55.7422Z",
    fill: "#75D3E3"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6623 22.4688L59.1973 25.0274L54.6333 27.586L50.1016 25.0274L54.6623 22.4688Z",
    fill: "#85E2F2"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1968 25.0234L63.7285 27.5821L59.1678 30.1407L54.6328 27.5821L59.1968 25.0234Z",
    fill: "#85E2F2"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2703 25.0234L72.8021 27.5821L68.2381 30.1407L63.7031 27.5821L68.2703 25.0234Z",
    fill: "#85E2F2"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7209 27.5898L68.2559 30.1485L63.6919 32.7071L59.1602 30.1485L63.7209 27.5898Z",
    fill: "#85E2F2"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7788 27.5898L77.3106 30.1485L72.7466 32.7071L68.2148 30.1485L72.7788 27.5898Z",
    fill: "#85E2F2"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7202 40.3867L27.252 42.9454L22.6913 45.504L18.1562 42.9454L22.7202 40.3867Z",
    fill: "#85E2F2"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2482 42.9414L31.7832 45.5L27.2193 48.0587L22.6875 45.5L27.2482 42.9414Z",
    fill: "#85E2F2"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8022 45.4961L36.334 48.0547L31.7733 50.6134L27.2383 48.0547L31.8022 45.4961Z",
    fill: "#85E2F2"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2241 48.0625L31.7591 50.6211L27.1919 53.1829L22.6602 50.6211L27.2241 48.0625Z",
    fill: "#85E2F2"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7342 55.7383L31.7696 68.469L27.2378 65.9104L27.1992 53.1797L31.7342 55.7383Z",
    fill: "#75D3E3"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7664 50.6133L36.2982 53.1719L31.7342 55.7337L27.1992 53.175L31.7664 50.6133Z",
    fill: "#85E2F2"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1403 19.9032L54.7024 17.3446L68.2988 25.0236L63.7367 27.5823L59.2067 25.0236L54.6767 22.465L50.1146 25.0236L45.5814 22.465L41.0193 25.0236L45.5525 27.5823L50.1146 25.0236L54.6446 27.5823L59.1745 30.1409L63.7045 32.6995L68.2666 30.1409L77.333 35.2613L72.7709 37.8199L68.2088 40.3786L72.7387 42.9372L68.1766 45.4959L63.6145 48.0545L59.0524 50.6131L54.4903 53.1718L49.9603 50.6131L45.3982 53.1718L40.836 55.7304L36.3029 53.1718L31.7729 50.6131L36.335 48.0545L31.805 45.4959L27.2751 42.9372L22.7451 40.3786L27.3072 37.8199L22.774 35.2613L18.2119 37.8199L22.7451 40.3786L18.183 42.9372L22.7129 45.4959L27.2429 48.0545L22.6808 50.6131L18.1508 48.0545L13.6208 45.4959L9.08767 42.9372L13.6498 40.3786L9.11981 37.8199L4.58984 35.2613L13.7109 30.144L9.1809 27.5854L27.4262 17.3477L31.9561 19.9063L41.0772 14.7891L50.1403 19.9063V19.9032ZM57.3484 31.6748L52.7863 34.2335L48.2563 31.6748L43.6942 34.2335L39.1321 36.7921L34.57 39.3507L39.0999 41.9094L34.5378 44.468L39.0678 47.0267L43.6299 44.468L39.0999 41.9094L43.662 39.3507L48.2242 36.7921L52.7863 34.2335L57.3163 36.7921L61.8784 34.2335L57.3484 31.6748Z",
    fill: "#E7D9FF"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M72.717 42.9453L77.252 45.504L72.688 48.0626L68.1562 45.504L72.717 42.9453Z",
    fill: "#85E2F2"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2514 45.5L77.2868 58.2338L72.7261 60.7925L72.6875 48.0586L77.2514 45.5Z",
    fill: "#75D3E3"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M72.688 48.0586L72.7266 60.7925L68.1916 58.2338L68.1562 45.5L72.688 48.0586Z",
    fill: "#85E2F2"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1577 45.4961L72.6895 48.0547L68.1255 50.6134L63.5938 48.0547L68.1577 45.4961Z",
    fill: "#85E2F2"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M72.689 48.0508L72.7275 60.7846L68.1636 63.3433L68.125 50.6094L72.689 48.0508Z",
    fill: "#75D3E3"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1255 50.6094L68.1641 63.3433L63.6323 60.7846L63.5938 48.0508L68.1255 50.6094Z",
    fill: "#85E2F2"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6333 53.175L63.6719 65.9058L59.1369 63.3471L59.1016 50.6133L63.6333 53.175Z",
    fill: "#85E2F2"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6655 48.0586L68.1973 50.6172L63.6333 53.179L59.1016 50.6172L63.6655 48.0586Z",
    fill: "#85E2F2"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1655 50.6133L68.2041 63.3471L63.6402 65.9058L63.6016 53.175L68.1655 50.6133Z",
    fill: "#75D3E3"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6115 53.1797L63.6501 65.9104L59.0862 68.469L59.0508 55.7383L63.6115 53.1797Z",
    fill: "#75D3E3"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0835 50.6133L63.6153 53.175L59.0545 55.7337L54.5195 53.175L59.0835 50.6133Z",
    fill: "#85E2F2"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0545 55.7383L59.0899 68.469L54.5581 65.9104L54.5195 53.1797L59.0545 55.7383Z",
    fill: "#85E2F2"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7258 48.0586L99.9153 63.4136L90.7942 68.5308L63.6016 53.179L72.7258 48.0586Z",
    fill: "#85E2F2"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7942 68.5315L90.8296 81.2654L63.6401 65.9104L63.6016 53.1797L90.7942 68.5315Z",
    fill: "#85E2F2"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9606 63.4102L99.9992 76.144L90.8713 81.2613L90.8359 68.5274L99.9606 63.4102Z",
    fill: "#75D3E3"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6694 50.6211L27.2012 53.1829L22.6405 55.7415L18.1055 53.1797L22.6694 50.6211Z",
    fill: "#85E2F2"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1974 53.1875L27.236 65.9182L22.6721 68.4768L22.6367 55.7461L27.1974 53.1875Z",
    fill: "#75D3E3"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6405 55.7375L22.6759 68.4683L18.1441 65.9096L18.1055 53.1758L22.6405 55.7375Z",
    fill: "#85E2F2"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2795 2.5625L63.8145 5.12114L59.2538 7.67977L54.7188 5.12114L59.2795 2.5625Z",
    fill: "#BD93F0"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8107 5.11719L63.8493 17.851L59.2854 20.4097L59.25 7.67583L63.8107 5.11719Z",
    fill: "#DCBEFF"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2538 7.67583L59.2891 20.4097L54.7541 17.851L54.7188 5.11719L59.2538 7.67583Z",
    fill: "#A773E4"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8107 5.10938L68.3457 7.66801L63.7818 10.2298L59.25 7.66801L63.8107 5.10938Z",
    fill: "#BD93F0"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3452 7.66406L68.3806 20.3979L63.8198 22.9565L63.7812 10.2258L68.3452 7.66406Z",
    fill: "#DCBEFF"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7818 10.2258L63.8204 22.9565L59.2854 20.3979L59.25 7.66406L63.7818 10.2258Z",
    fill: "#A773E4"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3061 7.67578L72.8379 10.2375L68.2772 12.7962L63.7422 10.2375L68.3061 7.67578Z",
    fill: "#BD93F0"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8342 10.2422L72.8728 22.9729L68.3088 25.5315L68.2734 12.8008L72.8342 10.2422Z",
    fill: "#DCBEFF"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2772 12.8008L68.3126 25.5315L63.7808 22.9729L63.7422 10.2422L68.2772 12.8008Z",
    fill: "#A773E4"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8303 10.2344L77.3653 12.793L72.8013 15.3517L68.2695 12.793L72.8303 10.2344Z",
    fill: "#BD93F0"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3647 12.7891L77.4001 25.5198L72.8394 28.0815L72.8008 15.3477L77.3647 12.7891Z",
    fill: "#DCBEFF"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8013 15.3477L72.8399 28.0815L68.3049 25.5198L68.2695 12.7891L72.8013 15.3477Z",
    fill: "#A773E4"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0646 2.55469L41.1032 15.2885L36.5393 17.8472L36.5039 5.11332L41.0646 2.55469Z",
    fill: "#DCBEFF"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5077 5.11332L36.543 17.8472L32.0113 15.2885L31.9727 2.55469L36.5077 5.11332Z",
    fill: "#A773E4"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5366 0L41.0684 2.55864L36.5077 5.11728L31.9727 2.55864L36.5366 0Z",
    fill: "#BD93F0"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5623 5.11332L45.5977 17.8472L41.0659 15.2885L41.0273 2.55469L45.5623 5.11332Z",
    fill: "#A773E4"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5945 0L50.1263 2.55864L45.5623 5.11728L41.0273 2.55864L45.5945 0Z",
    fill: "#BD93F0"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1225 2.55469L50.1611 15.2885L45.594 17.8472L45.5586 5.11332L50.1225 2.55469Z",
    fill: "#DCBEFF"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8358 7.67973L22.8712 20.4136L18.3362 17.8549L18.3008 5.12109L22.8358 7.67973Z",
    fill: "#A773E4"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8647 2.55469L27.3997 5.11332L22.8358 7.67196L18.3008 5.11332L22.8647 2.55469Z",
    fill: "#BD93F0"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M27.396 5.12109L27.4314 17.8549L22.8674 20.4136L22.832 7.67973L27.396 5.12109Z",
    fill: "#DCBEFF"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9748 2.55469L36.5098 5.11332L31.9458 7.67196L27.4141 5.11332L31.9748 2.55469Z",
    fill: "#BD93F0"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9458 7.67973L31.9844 20.4136L27.4494 17.8549L27.4141 5.12109L31.9458 7.67973Z",
    fill: "#A773E4"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5054 5.12109L36.5407 17.8549L31.98 20.4136L31.9414 7.67973L36.5054 5.12109Z",
    fill: "#DCBEFF"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M54.657 5.12109L54.6924 17.8549L50.1284 20.4136L50.0898 7.67973L54.657 5.12109Z",
    fill: "#DCBEFF"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1225 2.55469L54.6576 5.11332L50.0904 7.67196L45.5586 5.11332L50.1225 2.55469Z",
    fill: "#BD93F0"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0904 7.67973L50.129 20.4136L45.594 17.8549L45.5586 5.12109L50.0904 7.67973Z",
    fill: "#A773E4"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3061 5.12109L22.8411 7.67973L18.2772 10.2384L13.7422 7.67973L18.3061 5.12109Z",
    fill: "#BD93F0"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2772 10.2344L18.3158 22.9683L13.7808 20.4096L13.7422 7.67578L18.2772 10.2344Z",
    fill: "#A773E4"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8374 7.67578L22.8728 20.4096L18.312 22.9683L18.2734 10.2344L22.8374 7.67578Z",
    fill: "#DCBEFF"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7264 12.7922L13.7618 25.5261L9.22679 22.9643L9.19141 10.2305L13.7264 12.7922Z",
    fill: "#A773E4"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2827 10.2305L18.3213 22.9643L13.7541 25.5261L13.7188 12.7922L18.2827 10.2305Z",
    fill: "#DCBEFF"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7554 7.67578L18.2904 10.2344L13.7264 12.7962L9.19141 10.2344L13.7554 7.67578Z",
    fill: "#BD93F0"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5679 10.2422L45.6032 22.9729L41.0393 25.5315L41.0039 12.8008L45.5679 10.2422Z",
    fill: "#AFA2C2"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0819 12.8008L50.1173 25.5347L45.5823 22.9729L45.5469 10.2422L50.0819 12.8008Z",
    fill: "#797086"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6193 10.2422L54.6579 22.976L50.094 25.5347L50.0586 12.8008L54.6193 10.2422Z",
    fill: "#AFA2C2"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1522 12.8008L59.1876 25.5347L54.6558 22.976L54.6172 10.2422L59.1522 12.8008Z",
    fill: "#797086"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16391 15.3555L9.20251 28.0893L4.6675 25.5276L4.62891 12.7969L9.16391 15.3555Z",
    fill: "#A773E4"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7319 12.7969L13.7673 25.5307L9.20656 28.0893L9.16797 15.3555L13.7319 12.7969Z",
    fill: "#DCBEFF"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19286 10.2305L13.7279 12.7922L9.16391 15.3509L4.62891 12.7922L9.19286 10.2305Z",
    fill: "#BD93F0"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5679 10.2422L50.1029 12.8008L45.5389 15.3595L41.0039 12.8008L45.5679 10.2422Z",
    fill: "#BD93F0"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0522 12.7969L50.0876 25.5307L45.5269 28.0893L45.4883 15.3555L50.0522 12.7969Z",
    fill: "#DCBEFF"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5389 15.3555L45.5775 28.0893L41.0425 25.5276L41.0039 12.7969L45.5389 15.3555Z",
    fill: "#A773E4"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5904 15.3555L54.629 28.0893L50.094 25.5307L50.0586 12.7969L54.5904 15.3555Z",
    fill: "#4F767C"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1811 12.7969L59.2165 25.5307L54.6558 28.0893L54.6172 15.3555L59.1811 12.7969Z",
    fill: "#72AAB3"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6919 15.3555L63.7305 28.0893L59.1955 25.5307L59.1602 12.7969L63.6919 15.3555Z",
    fill: "#797086"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2508 12.7969L68.2861 25.5276L63.7222 28.0893L63.6836 15.3555L68.2508 12.7969Z",
    fill: "#AFA2C2"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M13.703 17.9102L13.7383 30.644L9.20656 28.0854L9.16797 15.3516L13.703 17.9102Z",
    fill: "#797086"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7014 15.3516L63.7399 28.0854L59.176 30.644L59.1406 17.9102L63.7014 15.3516Z",
    fill: "#72AAB3"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1522 17.9102L59.1876 30.644L54.6558 28.0854L54.6172 15.3516L59.1522 17.9102Z",
    fill: "#4F767C"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7788 15.3516L72.8174 28.0854L68.2502 30.644L68.2148 17.9102L72.7788 15.3516Z",
    fill: "#72AAB3"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2186 17.9102L68.254 30.644L63.7222 28.0854L63.6836 15.3516L68.2186 17.9102Z",
    fill: "#4F767C"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15058 15.3516L13.6856 17.9102L9.12163 20.4688L4.58984 17.9102L9.15058 15.3516Z",
    fill: "#BD93F0"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M9.12163 20.4766L9.16023 33.2104L4.62522 30.6518L4.58984 17.918L9.12163 20.4766Z",
    fill: "#A773E4"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7046 17.918L13.74 30.6518L9.17922 33.2104L9.14062 20.4766L13.7046 17.918Z",
    fill: "#DCBEFF"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2475 17.918L68.2829 30.6518L63.7222 33.2104L63.6836 20.4766L68.2475 17.918Z",
    fill: "#72AAB3"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6724 20.4766L63.711 33.2104L59.176 30.6518L59.1406 17.918L63.6724 20.4766Z",
    fill: "#4F767C"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7466 20.4766L72.7852 33.2104L68.2502 30.6518L68.2148 17.918L72.7466 20.4766Z",
    fill: "#4F767C"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3569 17.918L77.3955 30.6518L72.8316 33.2104L72.793 20.4766L77.3569 17.918Z",
    fill: "#72AAB3"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2436 19.4453L48.2822 32.1791L43.7183 34.7378L43.6797 22.0071L48.2436 19.4453Z",
    fill: "#AFA2C2"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2983 19.4453L57.3369 32.1791L52.773 34.7378L52.7344 22.0071L57.2983 19.4453Z",
    fill: "#AFA2C2"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7466 22.0071L52.7852 34.7378L48.2534 32.1791L48.2148 19.4453L52.7466 22.0071Z",
    fill: "#797086"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8592 22.0071L61.8946 34.7378L57.3628 32.1791L57.3242 19.4453L61.8592 22.0071Z",
    fill: "#797086"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M4.55913 23.0313L4.59773 35.7651L0.0627234 33.2065L0.0273438 20.4727L4.55913 23.0313Z",
    fill: "#A773E4"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M9.12645 20.4727L9.16505 33.2065L4.6011 35.7651L4.5625 23.0313L9.12645 20.4727Z",
    fill: "#DCBEFF"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M4.59129 17.918L9.12308 20.4766L4.55913 23.0352L0.0273438 20.4766L4.59129 17.918Z",
    fill: "#BD93F0"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8836 20.4727L81.919 33.2065L77.355 35.7651L77.3164 23.0344L81.8836 20.4727Z",
    fill: "#DCBEFF"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M77.328 23.0344L77.3666 35.7651L72.8316 33.2065L72.793 20.4727L77.328 23.0344Z",
    fill: "#A773E4"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3569 17.918L81.8951 20.4766L77.328 23.0384L72.793 20.4766L77.3569 17.918Z",
    fill: "#BD93F0"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6968 22.0117L43.7354 34.7424L39.1714 37.3042L39.1328 24.5704L43.6968 22.0117Z",
    fill: "#AFA2C2"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2147 24.5704L48.2501 37.3011L43.7183 34.7424L43.6797 22.0117L48.2147 24.5704Z",
    fill: "#A773E4"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7639 22.0117L52.8025 34.7424L48.2385 37.3011L48.2031 24.5704L52.7639 22.0117Z",
    fill: "#DCBEFF"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2436 19.4453L52.7754 22.0071L48.2147 24.5657L43.6797 22.0071L48.2436 19.4453Z",
    fill: "#BD93F0"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8374 22.0117L61.8728 34.7424L57.3088 37.3011L57.2734 24.5704L61.8374 22.0117Z",
    fill: "#DCBEFF"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2983 19.4453L61.8333 22.0071L57.2694 24.5657L52.7344 22.0071L57.2983 19.4453Z",
    fill: "#BD93F0"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2694 24.5704L57.3048 37.3011L52.773 34.7424L52.7344 22.0117L57.2694 24.5704Z",
    fill: "#A773E4"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0975 25.586L9.13288 38.3198L4.6011 35.7612L4.5625 23.0273L9.0975 25.586Z",
    fill: "#797086"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7593 23.0273L22.7946 35.7612L18.2307 38.3198L18.1953 25.586L22.7593 23.0273Z",
    fill: "#AFA2C2"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2811 25.5891L27.3165 38.3198L22.7815 35.7612L22.7461 23.0273L27.2811 25.5891Z",
    fill: "#797086"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3029 23.0391L77.3415 35.7698L72.7776 38.3315L72.7422 25.5977L77.3029 23.0391Z",
    fill: "#AFA2C2"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1147 24.5664L39.1533 37.3002L34.5894 39.8589L34.5508 27.125L39.1147 24.5664Z",
    fill: "#AFA2C2"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6646 27.125L43.7032 39.8589L39.1714 37.3002L39.1328 24.5664L43.6646 27.125Z",
    fill: "#A773E4"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1883 24.5664L48.2236 37.2971L43.6597 39.8589L43.6211 27.125L48.1883 24.5664Z",
    fill: "#DCBEFF"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6968 22.0117L48.2318 24.5704L43.6646 27.129L39.1328 24.5704L43.6968 22.0117Z",
    fill: "#BD93F0"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0952 25.5938L9.13058 38.3276L4.56663 40.8894L4.53125 28.1555L9.0952 25.5938Z",
    fill: "#DCBEFF"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M4.535 28.1524L4.57038 40.8862L0.0385942 38.3245L0 25.5938L4.535 28.1524Z",
    fill: "#A773E4"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M4.56395 23.0273L9.09895 25.586L4.535 28.1477L0 25.5891L4.56395 23.0273Z",
    fill: "#BD93F0"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6216 28.1524L13.6602 40.8862L9.12522 38.3276L9.08984 25.5938L13.6216 28.1524Z",
    fill: "#797086"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7303 28.1555L22.7689 40.8894L18.2339 38.3276L18.1953 25.5938L22.7303 28.1555Z",
    fill: "#A773E4"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2905 25.5938L27.3259 38.3245L22.7652 40.8862L22.7266 28.1524L27.2905 25.5938Z",
    fill: "#DCBEFF"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7593 23.0273L27.2943 25.5891L22.7303 28.1477L18.1953 25.586L22.7593 23.0273Z",
    fill: "#BD93F0"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7671 25.5938L72.8025 38.3276L68.2385 40.8862L68.2031 28.1524L72.7671 25.5938Z",
    fill: "#AFA2C2"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3029 23.0391L81.8379 25.5977L77.274 28.1563L72.7422 25.5977L77.3029 23.0391Z",
    fill: "#BD93F0"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8296 25.5938L81.8649 38.3276L77.3042 40.8862L77.2656 28.1524L81.8296 25.5938Z",
    fill: "#DCBEFF"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M77.274 28.1524L77.3126 40.8862L72.7776 38.3276L72.7422 25.5938L77.274 28.1524Z",
    fill: "#A773E4"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1147 24.5664L43.6465 27.125L39.0858 29.6837L34.5508 27.125L39.1147 24.5664Z",
    fill: "#BD93F0"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0858 29.6797L39.1212 42.4136L34.5894 39.8549L34.5508 27.1211L39.0858 29.6797Z",
    fill: "#A773E4"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6349 27.1211L43.6735 39.8549L39.1096 42.4136L39.0742 29.6797L43.6349 27.1211Z",
    fill: "#DCBEFF"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M9.06304 30.7032L9.10163 43.437L4.56663 40.8784L4.53125 28.1445L9.06304 30.7032Z",
    fill: "#A773E4"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6264 28.1445L13.665 40.8784L9.10109 43.4401L9.0625 30.7063L13.6264 28.1445Z",
    fill: "#DCBEFF"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0952 25.5938L13.627 28.1524L9.06304 30.7141L4.53125 28.1555L9.0952 25.5938Z",
    fill: "#BD93F0"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7085 28.1445L22.7471 40.8784L18.1831 43.437L18.1445 30.7032L22.7085 28.1445Z",
    fill: "#AFA2C2"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2583 30.7032L27.2969 43.437L22.7652 40.8784L22.7266 28.1445L27.2583 30.7032Z",
    fill: "#797086"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7349 30.7032L72.7735 43.437L68.2385 40.8784L68.2031 28.1445L72.7349 30.7032Z",
    fill: "#A773E4"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7671 25.5938L77.2989 28.1524L72.7349 30.711L68.2031 28.1524L72.7671 25.5938Z",
    fill: "#BD93F0"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2788 28.1445L77.3174 40.8784L72.7534 43.437L72.7148 30.7032L77.2788 28.1445Z",
    fill: "#DCBEFF"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1069 29.6875L39.1423 42.4213L34.5816 44.98L34.543 32.2461L39.1069 29.6875Z",
    fill: "#AFA2C2"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M43.606 32.2461L43.6446 44.98L39.1096 42.4213L39.0742 29.6875L43.606 32.2461Z",
    fill: "#797086"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5975 33.2696L13.6361 46.0034L9.10109 43.4448L9.0625 30.7109L13.5975 33.2696Z",
    fill: "#797086"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2443 30.7109L27.2829 43.4448L22.719 46.0034L22.6836 33.2696L27.2443 30.7109Z",
    fill: "#72AAB3"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6795 33.2696L22.7149 46.0034L18.1831 43.4448L18.1445 30.7109L22.6795 33.2696Z",
    fill: "#4F767C"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7928 33.2696L31.8282 46.0034L27.2964 43.4448L27.2578 30.7109L31.7928 33.2696Z",
    fill: "#797086"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6936 30.7109L72.7321 43.4448L68.1682 46.0034L68.1328 33.2696L72.6936 30.7109Z",
    fill: "#AFA2C2"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M39.078 34.8008L39.1133 47.5347L34.5816 44.976L34.543 32.2422L39.078 34.8008Z",
    fill: "#A773E4"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6115 32.2422L43.6501 44.976L39.0862 47.5347L39.0508 34.8008L43.6115 32.2422Z",
    fill: "#DCBEFF"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1069 29.6875L43.6387 32.2461L39.078 34.8048L34.543 32.2461L39.1069 29.6875Z",
    fill: "#BD93F0"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M9.06786 30.7109L13.6029 33.2696L9.03891 35.8282L4.50391 33.2696L9.06786 30.7109Z",
    fill: "#BD93F0"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03891 35.8282L9.07751 48.562L4.5425 46.0034L4.50391 33.2695L9.03891 35.8282Z",
    fill: "#A773E4"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6069 33.2695L13.6455 46.0034L9.08157 48.562L9.04297 35.8282L13.6069 33.2695Z",
    fill: "#DCBEFF"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1288 35.8282L18.1641 48.562L13.6323 46.0034L13.5938 33.2695L18.1288 35.8282Z",
    fill: "#797086"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M31.771 33.2695L31.8064 46.0034L27.2456 48.562L27.207 35.8282L31.771 33.2695Z",
    fill: "#72AAB3"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2154 35.8282L27.254 48.562L22.719 46.0034L22.6836 33.2695L27.2154 35.8282Z",
    fill: "#4F767C"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3208 35.8282L36.3594 48.562L31.8244 46.0034L31.7891 33.2695L36.3208 35.8282Z",
    fill: "#797086"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1655 33.2695L68.2009 46.0034L63.6402 48.562L63.6016 35.8282L68.1655 33.2695Z",
    fill: "#AFA2C2"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1382 35.832L18.1735 48.5659L13.6096 51.1245L13.5742 38.3907L18.1382 35.832Z",
    fill: "#DCBEFF"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6069 33.2695L18.1419 35.8282L13.578 38.3868L9.04297 35.8282L13.6069 33.2695Z",
    fill: "#BD93F0"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M13.578 38.3907L13.6134 51.1245L9.08157 48.5659L9.04297 35.832L13.578 38.3907Z",
    fill: "#A773E4"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2319 35.832L27.2705 48.5659L22.7066 51.1245L22.668 38.3907L27.2319 35.832Z",
    fill: "#AFA2C2"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6685 38.3907L22.7071 51.1245L18.1721 48.5659L18.1367 35.832L22.6685 38.3907Z",
    fill: "#797086"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M36.299 35.832L36.3376 48.5659L31.7737 51.1245L31.7383 38.3907L36.299 35.832Z",
    fill: "#72AAB3"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M31.742 38.3907L31.7774 51.1245L27.2456 48.5659L27.207 35.832L31.742 38.3907Z",
    fill: "#4F767C"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M63.56 35.832L63.5986 48.5659L59.0315 51.1245L58.9961 38.3907L63.56 35.832Z",
    fill: "#AFA2C2"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1382 35.832L22.67 38.3907L18.106 40.9493L13.5742 38.3907L18.1382 35.832Z",
    fill: "#BD93F0"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6577 38.3867L22.6963 51.1206L18.1323 53.6792L18.0938 40.9454L22.6577 38.3867Z",
    fill: "#DCBEFF"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M18.106 40.9454L18.1446 53.6792L13.6096 51.1206L13.5742 38.3867L18.106 40.9454Z",
    fill: "#A773E4"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1998 40.9485L27.2384 53.6792L22.7066 51.1206L22.668 38.3867L27.1998 40.9485Z",
    fill: "#4F767C"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7742 38.3867L31.8096 51.1206L27.2456 53.6792L27.207 40.9485L31.7742 38.3867Z",
    fill: "#72AAB3"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2701 40.9454L36.3087 53.6792L31.7737 51.1206L31.7383 38.3867L36.2701 40.9454Z",
    fill: "#797086"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M49.935 38.3867L49.9704 51.1206L45.4065 53.6792L45.3711 40.9485L49.935 38.3867Z",
    fill: "#AFA2C2"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4615 40.9485L54.5001 53.6792L49.9651 51.1206L49.9297 38.3867L54.4615 40.9485Z",
    fill: "#797086"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0171 38.3867L59.0524 51.1206L54.4917 53.6792L54.4531 40.9485L59.0171 38.3867Z",
    fill: "#AFA2C2"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2944 40.9414L36.333 53.6752L31.7658 56.2339L31.7305 43.5032L36.2944 40.9414Z",
    fill: "#72AAB3"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3647 40.9492L45.4001 53.6799L40.8394 56.2386L40.8008 43.5079L45.3647 40.9492Z",
    fill: "#AFA2C2"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8514 43.5032L40.89 56.2339L36.355 53.6752L36.3164 40.9414L40.8514 43.5032Z",
    fill: "#797086"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M49.935 38.3867L54.4668 40.9485L49.9029 43.5071L45.3711 40.9485L49.935 38.3867Z",
    fill: "#BD93F0"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4663 40.9492L54.5049 53.6799L49.9409 56.2386L49.9023 43.5079L54.4663 40.9492Z",
    fill: "#DCBEFF"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9029 43.5079L49.9415 56.2386L45.4065 53.6799L45.3711 40.9492L49.9029 43.5079Z",
    fill: "#A773E4"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2944 40.9414L40.8294 43.5032L36.2655 46.0618L31.7305 43.5032L36.2944 40.9414Z",
    fill: "#BD93F0"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8335 43.5078L40.8721 56.2385L36.3081 58.8003L36.2695 46.0665L40.8335 43.5078Z",
    fill: "#DCBEFF"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2655 46.0665L36.3041 58.8003L31.7658 56.2385L31.7305 43.5078L36.2655 46.0665Z",
    fill: "#A773E4"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3647 40.9492L49.8965 43.5079L45.3358 46.0665L40.8008 43.5079L45.3647 40.9492Z",
    fill: "#BD93F0"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3358 46.0665L45.3712 58.7972L40.8394 56.2385L40.8008 43.5078L45.3358 46.0665Z",
    fill: "#A773E4"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M49.885 43.5078L49.9235 56.2385L45.3596 58.7972L45.3242 46.0665L49.885 43.5078Z",
    fill: "#DCBEFF"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6623 10.2344L59.1973 12.793L54.6333 15.3517L50.1016 12.793L54.6623 10.2344Z",
    fill: "#85E2F2"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1968 12.7891L63.7285 15.3477L59.1678 17.9063L54.6328 15.3477L59.1968 12.7891Z",
    fill: "#85E2F2"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2703 12.7891L72.8021 15.3477L68.2381 17.9063L63.7031 15.3477L68.2703 12.7891Z",
    fill: "#85E2F2"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7209 15.3555L68.2559 17.9141L63.6919 20.4727L59.1602 17.9141L63.7209 15.3555Z",
    fill: "#85E2F2"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7788 15.3555L77.3106 17.9141L72.7466 20.4727L68.2148 17.9141L72.7788 15.3555Z",
    fill: "#85E2F2"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7202 28.1523L27.252 30.711L22.6913 33.2696L18.1562 30.711L22.7202 28.1523Z",
    fill: "#85E2F2"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2482 30.707L31.7832 33.2657L27.2193 35.8243L22.6875 33.2657L27.2482 30.707Z",
    fill: "#85E2F2"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8022 33.2617L36.334 35.8204L31.7733 38.379L27.2383 35.8204L31.8022 33.2617Z",
    fill: "#85E2F2"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2241 35.8281L31.7591 38.3868L27.1919 40.9485L22.6602 38.3868L27.2241 35.8281Z",
    fill: "#85E2F2"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7342 43.504L31.7696 56.2347L27.2378 53.676L27.1992 40.9453L31.7342 43.504Z",
    fill: "#75D3E3"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7664 38.3789L36.2982 40.9375L31.7342 43.4993L27.1992 40.9407L31.7664 38.3789Z",
    fill: "#85E2F2"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1403 7.66884L54.7024 5.1102L68.2988 12.7892L63.7367 15.3479L59.2067 12.7892L54.6767 10.2306L50.1146 12.7892L45.5814 10.2306L41.0193 12.7892L45.5525 15.3479L50.1146 12.7892L54.6446 15.3479L59.1745 17.9065L63.7045 20.4652L68.2666 17.9065L77.333 23.0269L72.7709 25.5856L68.2088 28.1442L72.7387 30.7028L68.1766 33.2615L63.6145 35.8201L59.0524 38.3788L54.4903 40.9374L49.9603 38.3788L45.3982 40.9374L40.836 43.496L36.3029 40.9374L31.7729 38.3788L36.335 35.8201L31.805 33.2615L27.2751 30.7028L22.7451 28.1442L27.3072 25.5856L22.774 23.0269L18.2119 25.5856L22.7451 28.1442L18.183 30.7028L22.7129 33.2615L27.2429 35.8201L22.6808 38.3788L18.1508 35.8201L13.6208 33.2615L9.08767 30.7028L13.6498 28.1442L9.11981 25.5856L4.58984 23.0269L13.7109 17.9096L9.1809 15.351L27.4262 5.11333L31.9561 7.67197L41.0772 2.55469L50.1403 7.67197V7.66884ZM57.3484 19.4405L52.7863 21.9991L48.2563 19.4405L43.6942 21.9991L39.1321 24.5577L34.57 27.1164L39.0999 29.675L34.5378 32.2337L39.0678 34.7923L43.6299 32.2337L39.0999 29.675L43.662 27.1164L48.2242 24.5577L52.7863 21.9991L57.3163 24.5577L61.8784 21.9991L57.3484 19.4405Z",
    fill: "#E7D9FF"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M72.717 30.7109L77.252 33.2696L72.688 35.8282L68.1562 33.2696L72.717 30.7109Z",
    fill: "#BD93F0"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2514 33.2656L77.2868 45.9995L72.7261 48.5581L72.6875 35.8243L77.2514 33.2656Z",
    fill: "#DCBEFF"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M72.688 35.8243L72.7266 48.5581L68.1916 45.9995L68.1562 33.2656L72.688 35.8243Z",
    fill: "#A773E4"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1889 33.2734L72.7207 35.8321L68.1568 38.3907L63.625 35.8321L68.1889 33.2734Z",
    fill: "#BD93F0"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7202 35.8281L72.7588 48.562L68.1948 51.1206L68.1562 38.3868L72.7202 35.8281Z",
    fill: "#DCBEFF"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1568 38.3868L68.1954 51.1206L63.6636 48.562L63.625 35.8281L68.1568 38.3868Z",
    fill: "#A773E4"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M63.606 40.9407L63.6446 53.6714L59.1096 51.1127L59.0742 38.3789L63.606 40.9407Z",
    fill: "#A773E4"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6382 35.8242L68.17 38.3829L63.606 40.9446L59.0742 38.3829L63.6382 35.8242Z",
    fill: "#BD93F0"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1577 38.3789L68.1963 51.1127L63.6323 53.6714L63.5938 40.9407L68.1577 38.3789Z",
    fill: "#DCBEFF"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6037 40.9453L63.6423 53.676L59.0784 56.2347L59.043 43.504L63.6037 40.9453Z",
    fill: "#DCBEFF"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0757 38.3789L63.6075 40.9407L59.0467 43.4993L54.5117 40.9407L59.0757 38.3789Z",
    fill: "#BD93F0"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0467 43.504L59.0821 56.2347L54.5503 53.676L54.5117 40.9453L59.0467 43.504Z",
    fill: "#A773E4"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M72.718 35.8242L99.9075 51.1792L90.7864 56.2965L63.5938 40.9446L72.718 35.8242Z",
    fill: "#BD93F0"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7864 56.2971L90.8218 69.031L63.6323 53.676L63.5938 40.9453L90.7864 56.2971Z",
    fill: "#A773E4"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9528 51.1758L99.9914 63.9096L90.8635 69.0269L90.8281 56.2931L99.9528 51.1758Z",
    fill: "#DCBEFF"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6694 38.3867L27.2012 40.9485L22.6405 43.5071L18.1055 40.9454L22.6694 38.3867Z",
    fill: "#BD93F0"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1974 40.9531L27.236 53.6838L22.6721 56.2425L22.6367 43.5118L27.1974 40.9531Z",
    fill: "#DCBEFF"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6405 43.5032L22.6759 56.2339L18.1441 53.6752L18.1055 40.9414L22.6405 43.5032Z",
    fill: "#A773E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSearchResults);
export default __webpack_public_path__ + "static/media/no-search-results.34b537ce93c814de8f1da5a7cd0e2dbd.svg";
export { ForwardRef as ReactComponent };